import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sdk-utilities"
    }}>{`SDK Utilities`}</h1>
    <p>{`This page covers various utilities provided by the Adobe PDF Services SDKs, including operations such as refreshing
download URIs, deleting assets, and streamline your workflows.`}</p>
    <h2 {...{
      "id": "important-note-on-expiry"
    }}>{`Important Note on Expiry`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Asset Expiry : Assets uploaded to Adobe internal storage are transiently stored for 24 hours.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Pre-signed URI Expiry : The pre-signed URI provided for uploading or downloading the content has an expiry of 1 hour.`}</p>
      </li>
    </ul>
    <p>{`See our public API Reference for assets `}<a parentName="p" {...{
        "href": "../../../apis/#tag/Assets"
      }}>{`here`}</a>{`.`}</p>
    <h2 {...{
      "id": "refresh-download-uri"
    }}>{`Refresh Download URI`}</h2>
    <p>{`This function will create a new download URI for your asset. This is useful for scenarios where the asset needs to be
downloaded after its URI has expired.`}</p>
    <CodeBlock slots="heading, code" repeat="4" languages="Java, Node.js, Python, .NET" mdxType="CodeBlock" />
    <h3 {...{
      "id": "java"
    }}>{`Java`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`CreatePDFResult result = pdfServicesResponse.getResult();
Asset asset = result.getAsset();

// refresh the download URI in case it expires or is null for the uploaded asset
Asset refreshedAsset = pdfServices.refreshDownloadURI(asset);
`}</code></pre>
    <h3 {...{
      "id": "nodejs"
    }}>{`Node.js`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const result = pdfServicesResponse.result;
const asset = result.asset;

// refresh the download URI in case it expires or is null for the uploaded asset
const refreshedAsset = await pdfServices.refreshDownloadURI({asset});
`}</code></pre>
    <h3 {...{
      "id": "python"
    }}>{`Python`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`result = pdf_services_response.getResult()
asset = result.getAsset()

# refresh the download URI in case it expires or is null for the uploaded asset
refreshed_asset = pdf_services.refreshDownloadURI(asset);
`}</code></pre>
    <h3 {...{
      "id": "net"
    }}>{`.NET`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`CreatePDFResult result = pdfServicesResponse.Result;
IAsset asset = result.Asset;
 
// refresh the download URI in case it expires or is null for the uploaded asset
pdfServices.RefreshDownloadURI(asset);
`}</code></pre>
    <h2 {...{
      "id": "delete-asset"
    }}>{`Delete Asset`}</h2>
    <p>{`This function deletes an asset from Adobe internal storage. If you prefer not to store your asset on Adobe's storage,
where assets are transiently stored for 24 hours, you can use this function to delete the asset immediately.`}</p>
    <CodeBlock slots="heading, code" repeat="4" languages="Java, Node.js, Python, .NET" mdxType="CodeBlock" />
    <h3 {...{
      "id": "java-1"
    }}>{`Java`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`CreatePDFResult result = pdfServicesResponse.getResult();
Asset asset = result.getAsset();
 
// delete asset
pdfServices.deleteAsset(asset);
`}</code></pre>
    <h3 {...{
      "id": "nodejs-1"
    }}>{`Node.js`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const result = pdfServicesResponse.result;
const asset = result.asset;

// delete asset
await pdfServices.deleteAsset({asset});
`}</code></pre>
    <h3 {...{
      "id": "python-1"
    }}>{`Python`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`create_pdf_result = pdf_services_response.getResult()
output_asset = create_pdf_result.getAsset()        

# delete asset
pdf_services.deleteAsset(output_asset);
`}</code></pre>
    <h3 {...{
      "id": "net-1"
    }}>{`.NET`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`CreatePDFResult result = pdfServicesResponse.Result;
IAsset asset = result.Asset;
 
// delete asset
pdfServices.deleteAsset(asset);
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      